import { useTranslation } from "react-i18next";
import { formatNumber, formatPercent } from "../../../utils/formatNumber";
import { cva } from "../../../../styled-system/css/cva";
import { css } from "../../../../styled-system/css";
import { Grid } from "../../../../styled-system/jsx";

interface Props {
  selected?: boolean;
  shelf: {
    name: string;
    brand_name: string;
    searches: unknown[];
    stats: { position_avg?: number; share_of_shelf: number };
  };
  onClick?: () => void;
}

const ShelfSummaryTile = ({ selected, shelf, onClick }: Props) => {
  const { t } = useTranslation(["analytics"]);
  return (
    <div
      onClick={onClick}
      className={cva({
        base: { borderRadius: "card", padding: "medium", backgroundColor: "white" },
        variants: {
          selected: {
            true: {
              color: "white",
              backgroundColor: "trellisPalette.3",
            },
          },
        },
      })({ selected })}
    >
      <h4
        className={css({
          margin: 0,
          color: "inherit",
          fontWeight: "bold",
        })}
      >
        {shelf.name}
      </h4>
      <Grid gap="xsmall" fontSize="medium" columns={2}>
        <span>{t(($) => $.analytics.shelf["Home Brand"])}</span>
        <span className={css({ justifySelf: "end" })}>{shelf.brand_name}</span>
        <span>{t(($) => $.analytics.shelf["Searches"], { count: shelf.searches.length })}</span>
        <span />
        <span>{t(($) => $.analytics.shelf["Share of Shelf"])}</span>
        <span className={css({ justifySelf: "end" })}>{formatPercent(shelf.stats.share_of_shelf / 100)}</span>
        <span>{t(($) => $.analytics.shelf["Average Rank"])}</span>
        <span className={css({ justifySelf: "end" })}>
          {formatNumber(shelf.stats.position_avg, { decimalPlaces: 2 })}
        </span>
      </Grid>
    </div>
  );
};

export default ShelfSummaryTile;
